import { CheckIcon, Table, TableColumnConfig } from '@weave/design-system';
import { FC, useMemo } from 'react';
import { formatDate } from 'helpers/date';
import { formatPhoneNumber } from 'helpers/utils';
import { useGetSentInviteLinkHistory } from '../onboarding.queries';
import { useSelector } from 'react-redux';
import { selectCurrentLocationId } from 'redux/actions/location';
import { GetSentInviteLinkHistoryResponseRow } from '../onboarding.types';
import { SentSMSStatusLabelMap } from '../onboarding.constants';

export const SentInviteAuditLogs: FC = () => {
  const locationId = useSelector(selectCurrentLocationId);
  const { data: sentInviteLinkHistory = [], isLoading } = useGetSentInviteLinkHistory({
    locationId,
  });
  const colConfig = useMemo<TableColumnConfig<GetSentInviteLinkHistoryResponseRow>[]>(
    () => [
      {
        Header: 'Sent',
        accessor: ({ sentAt }) => formatDate(sentAt, 'llll', true),
        id: 'sentAt',
        minWidth: 300,
      },
      {
        Header: 'Sent To',
        accessor: ({ phoneNumber }) => formatPhoneNumber(phoneNumber),
        id: 'phoneNumber',
        width: 200,
      },
      {
        Header: 'By User',
        accessor: 'sentBy',
        id: 'sentBy',
        minWidth: 350,
      },
      {
        Header: 'Status',
        accessor: ({ messageStatus }) => SentSMSStatusLabelMap[messageStatus],
        id: 'messageStatus',
      },
    ],
    []
  );

  return (
    <Table isLoading={isLoading} data={sentInviteLinkHistory} colConfig={colConfig} />
  );
};
